export default "__VITE_ASSET__CPCAN$pB__"